import { render, staticRenderFns } from "./CamaraAlerta.vue?vue&type=template&id=48fb8565&"
import script from "./CamaraAlerta.vue?vue&type=script&lang=ts&"
export * from "./CamaraAlerta.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraAlerta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports